import { ActivityReportInternshipServiceInterface } from 'domain/services';
import { ActivityReportInternshipLocationUseCaseInterface } from 'domain/usecases';

export class ActivityReportService
  implements ActivityReportInternshipServiceInterface
{
  constructor(
    private readonly _getActivityReportInternship: ActivityReportInternshipLocationUseCaseInterface,
  ) {}

  async getActivityReportInternshipInterface(
    params: ActivityReportInternshipLocationUseCaseInterface.Params,
  ): Promise<ActivityReportInternshipLocationUseCaseInterface.Result> {
    return await this._getActivityReportInternship.execute(params);
  }
}
